import * as _ from "lodash";
import * as z from "../../../framework";
import { RightLockable } from "../../../framework/components/components/component";
import K_EditableTable from "../templates/K_EditableTable";
import * as ui from "../ui";

interface EditableTableOptions extends ui.ComponentOptions {
    columns?: EditableTableColumn[];
    entityType?: string;
    required?: boolean | "true";
    parentId?: string;
    parentEntityType?: string;
    entityAlias?: string;
    headerClasses?: string;
    editableColumnClasses?: string;
    data?: any[];
    checkCount?: boolean | "true";
    maxRows?: number | string;
    select?: string;
    expand?: string;
    afterRenderTable?: string;
    observableChildren?: any;
    dataSource?: any;
    tableType?: string;
    useNew?: boolean | "true";
    usingScreenIds?: boolean | "true" | "false";
    requiredRight?: string;
}

type EditableTableColumn = ComboBoxColumn | LabelColumn | NumericInputColumn | TextBoxColumn;

interface Column {
    id?: string;
    bindValue?: string;
    field?: string;
    title?: string;
    labelWidth?: number | string;
    valueWidth?: number | string;
    containerClasses?: string;
    classes?: string;
    bsc?: string;
    inputBsc?: string;
    labelBsc?: string;
    disabled?: boolean;
    required?: boolean | "true" | "false";
    readonly?: boolean | "true";
    iconType?: string;
    iconId?: string;
    iconClasses?: string;
    dataTextField?: string;
}

interface ComboBoxColumn extends Column {
    type: "ComboBox";
    bindNumberValue?: string;
}

interface LabelColumn extends Column {
    type: "Label";
    bindClass?: string;
}

interface NumericInputColumn extends Column {
    type: "NumericInput";
    format?: string;
    min?: string | number;
    max?: string | number;
    decimals?: string | number;
}

interface TextBoxColumn extends Column {
    type: "TextBox";
    maxLength?: string;
    autocompleteSelectCallback?: string;
    searchResultsCallback?: string;
    format?: string;
}

export class EditableTable extends ui.TemplateComponent {

    options: EditableTableOptions & RightLockable;
    zScreen: any;
    parentId: any;
    parentEntityType: any;
    entityType: any;
    entityAlias: any;
    columns: EditableTableColumn[];
    headerClasses: any;
    editableColumnClasses: any;
    data: any;
    checkCount: any;
    required: any;
    maxRows: any;
    select: any;
    expand: any;
    afterRenderTable: any;
    observableChildren: any;
    disabled: any;
    dataSource: any;
    container: any;
    mainColumn: EditableTableColumn;
    rowTemplate: EditableTableColumn[];
    tableDataContainer: any;
    events: any;
    model: any;
    dataTemplate: EditableTableColumn[];
    observableName: any;
    requestObservableName: any;

    constructor(options: EditableTableOptions) {
        super(K_EditableTable, options);
    }

    preRender() {
        const options = this.options;

        if (options.requiredRight) {
            options.rightLocked = !z.userHasRight(options.requiredRight);

            if (options.rightLocked) {
                options.disabled = true;
                this.recursiveDisable = true;
                options.required = false;
                options.classes += " right-locked";
                options.containerClasses += " right-locked";
            }
        }

        this.parentId = options.parentId;
        this.parentEntityType = options.parentEntityType;
        this.entityType = options.entityType;
        this.entityAlias = options.entityAlias || options.entityType;
        this.columns = options.columns || [];
        this.headerClasses = options.headerClasses || "";
        this.editableColumnClasses = options.editableColumnClasses || "";
        this.data = options.data || [];
        this.checkCount = options.checkCount || false;
        this.required = options.required || false;
        this.maxRows = options.maxRows == null ? 4 : options.maxRows;
        this.select = options.select || "";
        this.expand = options.expand || "";
        this.afterRenderTable = options.afterRenderTable || "";
        this.observableChildren = options.observableChildren || null;
        this.disabled = options.disabled;

        this.dataSource = options.dataSource || new kendo.data.DataSource({ data: [] });
    }

    create() {
        var me = this;
        const args = me.options;
        var container = me.container = $("#" + me.id);
        var schema = z.schemas[me.entityType] || z.schemas[args.tableType] || {};

        if (me.options.useNew) {
            let components: ui.Component[] = [];
            $.each(me.columns, function (index: any, column) {
                if (index == 0) {
                    me.mainColumn = column;
                }

                var width = column.valueWidth || column.labelWidth || "auto";
                if (column.iconType && me.options.rightLocked != true) {
                    width = parseInt(width as string, 10) + 24;
                }

                var columnHeader = new ui.Label({
                    classes: "editable-table-header bind-label " + me.editableColumnClasses + " " + column.classes,
                    bindValue: column.title || column.field,
                    labelWidth: width
                });

                components.push(columnHeader);

                if (column.field.indexOf(".") != -1) {
                    var expand = column.field.substring(0, column.field.indexOf("."));

                    if (me.expand.indexOf(expand) == -1) {
                        if (me.expand) {
                            me.expand += ", ";
                        }
                        me.expand += expand;
                    }
                }

                if (me.select) {
                    me.select += ", ";
                }

                me.select += column.field;
            });

            components.push(new ui.HTML({
                HTML: "<div class='add " + (me.disabled ? "disabled" : "") + (me.recursiveDisable ? " field-visibility-disabled" : "") + "' title='" + z.ll("Add" + me.entityAlias, true) + "'></div>"
            }));

            me.rowTemplate = [];
            $.each(me.columns, function (index, column) {
                column.type = column.type || "TextBox";
                column.labelWidth = column.labelWidth || 0;
                column.valueWidth = column.valueWidth || 50;
                column.containerClasses = column.containerClasses || "editable-table-elem";
                column.bsc = column.bsc || " ";
                column.inputBsc = column.inputBsc || " ";
                column.labelBsc = column.labelBsc || " ";
                column.disabled = me.disabled;

                if (me.recursiveDisable) {
                    column.containerClasses = column.containerClasses + " field-visibility-disabled";
                    column.classes = column.classes + " field-visibility-disabled";
                }

                var childJson = column;

                if (me.options.rightLocked) {
                    childJson.iconClasses = undefined;
                    childJson.iconId = undefined;
                    childJson.iconType = undefined;
                }

                me.rowTemplate.push(childJson);
            });

            var headerContainerLayout = new ui.Container({
                classes: "editable-header-container " + me.headerClasses,
                components: components
            });
            headerContainerLayout.render(container);
            container.append("<div class='editable-data-container'></div>");

            me.tableDataContainer = container.find(".editable-data-container");

            container.find(".add").tie("click", function () {
                me.addRow();
            });

            container.data("editableTable", me);
        } else {
            me.addRow = function () {
                var numDeleted = me.countRow();
                if ((me.dataSource._data.length - numDeleted) < me.options.maxRows) {
                    var data = me.dataSource.data();
                    var callbackObject = {
                        sender: me,
                        data: data,
                        isDefaultPrevented: function () {
                            return this.defaultPrevented;
                        },
                        preventDefault: function () {
                            this.defaultPrevented = true;
                        },
                        defaultPrevented: false
                    };

                    me.events && me.events.adding && $.each(me.events.adding, function (i, callback) {
                        callback(callbackObject);
                    });

                    if (!callbackObject.isDefaultPrevented()) {
                        me.dataSource.add($.extend({}, me.model));
                        me.refresh();

                        data = me.dataSource.data();
                        var row = data[data.length - 1];
                        me.events && me.events.add && $.each(me.events.add, function (i, callback) {
                            callback({ sender: me, row: row });
                        });
                    }
                }
            };

            me.model = {};
            $.each(schema.Properties, function (key) {
                me.model[key] = null;
            });

            $.each(schema.NavigationProperties, function (key, value) {
                if (value.IsCollection) {
                    me.model[key] = [];
                } else {
                    me.model[key] = {};
                }
            });

            container.data("EditableTable", me);

            var headerContainer = $("<div class='editable-header-container " + args.headerClasses + "'></div>");
            $.each(args.columns, function (index, column) {
                var headerElem = $("<div class='editable-table-header bind-label " + args.editableColumnClasses + "' data-bind='text: " + (column.title || column.field || column) + "'></div>");

                if (column.labelWidth || column.valueWidth) {
                    var width = column.valueWidth || column.labelWidth;
                    if (column.iconType) {
                        width = parseInt(width as any, 10) + 24;
                    }
                    headerElem.css("width", width);
                }

                headerContainer.append(headerElem);
            });

            $("<div class='add " + (me.disabled ? "disabled" : "") + (me.recursiveDisable ? " field-visibility-disabled" : "") + "' title='" + z.ll("Add" + args.tableType, true) + "'></div>").appendTo(headerContainer);

            me.dataTemplate = [];
            $.each(me.options.columns, function (index, column) {
                column.type = column.type || "TextBox";
                column.labelWidth = column.labelWidth || 0;
                column.valueWidth = column.valueWidth || 50;
                column.containerClasses = column.containerClasses || "editable-table-elem";
                column.bsc = column.bsc || " ";
                column.inputBsc = column.inputBsc || " ";
                column.labelBsc = column.labelBsc || " ";
                column.disabled = me.disabled;

                if (me.recursiveDisable) {
                    column.containerClasses = column.containerClasses + " field-visibility-disabled";
                    column.classes = column.classes + " field-visibility-disabled";
                }

                var childJson = column;

                me.dataTemplate.push(childJson);
            });

            container.append(headerContainer);
            container.append("<div class='editable-data-container'></div>");

            var deletedLength = me.countRow();
            if (me.options.required && (me.dataSource._data.length - deletedLength == 0)) {
                container.find(".add").addClass("disabled");
            }

            container.find(".add").on("click", function () {
                var elem = $(this);

                if (!elem.hasClass("disabled")) {
                    me.addRow();
                }
            });

            me.refresh();
        }
    }

    addRow() {
        var me = this;

        if (me.data.length >= me.maxRows) {
            return;
        }

        me.data.push({});
        var index = me.data.length - 1;

        var object = {};

        var properties = me.expand.split(", ");

        $.each(properties, function (i, prop) {
            object[prop] = {};
        });

        var observable;
        var requestObservable;
        if (index == 0) {
            if (me.observableChildren) {
                observable = me.zScreen[me.observableName];
                requestObservable = me.zScreen[me.requestObservableName];
                $.each(me.observableChildren, function (i, child) {
                    observable[child] = observable[child] || {};
                    requestObservable[child] = requestObservable[child] || {};
                    observable = observable[child];
                    requestObservable = requestObservable[child];
                });
                observable = [object];
                requestObservable = [object];
            } else {
                me.zScreen[me.observableName][me.entityAlias][index] = object;
                me.zScreen[me.requestObservableName][me.entityAlias][index] = object;
            }
        } else {
            if (me.observableChildren) {
                observable = me.zScreen[me.observableName];
                requestObservable = me.zScreen[me.requestObservableName];
                $.each(me.observableChildren, function (i, child) {
                    observable[child] = observable[child] || {};
                    requestObservable[child] = requestObservable[child] || {};
                    observable = observable[child];
                    requestObservable = requestObservable[child];
                });

                observable[me.entityAlias][index] = object;
                requestObservable[me.entityAlias][index] = object;
            } else if (object) {
                me.zScreen[me.observableName][me.entityAlias][index] = object;
                me.zScreen[me.requestObservableName][me.entityAlias][index] = object;
            }
        }

        me.renderRow({
            index: index,
            row: me.data[index]
        });

        if (me.data.length >= me.maxRows) {
            me.container.find(".add").disable();
        }
    }

    bindData(args) {
        var me = this;
        args = args || {};

        if (args.parentId) {
            me.container.mask();
            me.parentId = args.parentId;
            var url = "" + me.entityAlias + "?$filter=" + me.parentEntityType + "Id eq " + args.parentId;

            if (me.select) {
                url += "&$select=" + me.select;
            }
            if (me.expand) {
                url += "&$expand=" + me.expand;
            }

            var observable;
            var requestObservable;
            z.ajax({
                url: url
            }).done(function (response) {
                if (me.observableChildren) {
                    observable = me.zScreen[me.observableName];
                    requestObservable = me.zScreen[me.requestObservableName];
                    $.each(me.observableChildren, function (index, child) {
                        observable[child] = observable[child] || {};
                        requestObservable[child] = requestObservable[child] || {};
                        observable = observable[child];
                        requestObservable = requestObservable[child];
                    });
                    observable[me.entityAlias] = response.d.results;
                    requestObservable[me.entityAlias] = response.d.results;
                } else {
                    me.zScreen[me.observableName][me.entityAlias] = response.d.results;
                    me.zScreen[me.requestObservableName][me.entityAlias] = response.d.results;
                }
                me.data = response.d.results;
                me.renderTable();
                me.container.unmask();
            });
        } else if (args.data) {
            if (me.observableChildren) {
                observable = me.zScreen[me.observableName];
                requestObservable = me.zScreen[me.requestObservableName];
                $.each(me.observableChildren, function (index, child) {
                    observable[child] = observable[child] || {};
                    requestObservable[child] = requestObservable[child] || {};
                    observable = observable[child];
                    requestObservable = requestObservable[child];
                });
                observable[me.entityAlias] = args.data;
                requestObservable[me.entityAlias] = args.data;
            } else {
                me.zScreen[me.observableName][me.entityAlias] = args.data;
                me.zScreen[me.requestObservableName][me.entityAlias] = args.data;
            }
            me.data = args.data;
            me.renderTable();
        } else {
            var data = [];
            if (me.observableChildren) {
                observable = me.zScreen[me.observableName];
                requestObservable = me.zScreen[me.requestObservableName];
                $.each(me.observableChildren, function (index, child) {
                    observable[child] = {};
                    requestObservable[child] = {};
                    observable = observable[child];
                    requestObservable = requestObservable[child];
                });
                observable[me.entityAlias] = data;
                requestObservable[me.entityAlias] = data;
            } else {
                me.zScreen[me.observableName][me.entityAlias] = data;
                me.zScreen[me.requestObservableName][me.entityAlias] = data;
            }
            me.data = data;
            me.renderTable();
        }
    }

    renderTable() {
        var me = this;
        var autocompletes = me.tableDataContainer.find(".k-autocomplete input");

        $.each(autocompletes, function (index, autocomplete) {
            $(autocomplete).data("kendoAutoComplete").destroy();
        });

        me.tableDataContainer.empty();

        if (me.data.length == 0) {
            me.addRow();
        } else {
            $.each(me.data, function (index, row) {
                me.renderRow({
                    index: index,
                    row: row
                });
            });
        }

        me.zScreen[me.afterRenderTable] && me.zScreen[me.afterRenderTable]();
    }

    renderRow(args) {
        var me = this;
        var row = args.row;
        var index = args.index;

        var observable = z.observable(row);
        var autocompletes = [];

        var components: ui.Component[] = [];

        var rowContainerId = me.id + "_Row" + index;
        observable.rowId = index;

        $.each(me.rowTemplate, function (i2, field) {
            field = _.cloneDeep(field);
            field.id = rowContainerId + "_" + field.id;
            if (field.iconId) {
                field.iconId = rowContainerId + "_" + field.iconId;
                field.dataTextField = field.dataTextField || field.bindValue.getStringAfterLastIndexOf(".");
                autocompletes.push(_.cloneDeep(field));
            }

            if (field.type == "ComboBox") {
                components.push(new ui.ComboBox(field));
            } else if (field.type == "Label") {
                components.push(new ui.Label(field));
            } else if (field.type == "NumericInput") {
                components.push(new ui.NumericInput(field));
            } else if (field.type == "TextBox") {
                components.push(new ui.TextBox(field));
            }
        });

        if (!me.options.rightLocked) {
            components.push(
                new ui.Element({
                    classes: "trash" + (me.recursiveDisable
                        ? " field-visibility-disabled"
                        : ""),
                    containerClasses: me.recursiveDisable
                        ? "field-visibility-disabled"
                        : "",
                    toolTip: "Remove" + me.entityAlias,
                    disabled: me.disabled
                })
            );
        }

        var rowContainerLayout = new ui.Container({
            id: rowContainerId,
            type: "Container",
            classes: "editable-row-container",
            components: components
        });

        rowContainerLayout.render(me.tableDataContainer);

        z.bind({ container: "#" + rowContainerId, bind: ".bind-label", data: z.LocalizedLanguage });
        z.bind({ container: "#" + rowContainerId, bind: ".bind-value", data: observable });

        // Anything with an IconId make sure to setup as an autocomplete
        $.each(autocompletes, function (i, autocomplete) {
            var split = autocomplete.bindValue.split(".");
            var entityType = split[0];
            var autocompleteArgs = {
                id: autocomplete.id,
                entityType: entityType,
                dataTextField: autocomplete.dataTextField,
                select: function (e) {
                    var data = this.dataItem(e.item.index());
                    observable.set(entityType, data);
                    observable.set(entityType + "Id", data.Id);
                    me.zScreen[autocomplete.autocompleteSelectCallback] && me.zScreen[autocomplete.autocompleteSelectCallback]({ data: data, observable: observable });
                },
                filterExpression: function () {
                    var ids = $.map(me.data, function (data) {
                        return data[entityType + "Id"];
                    });

                    return z.filter.isNotIn("Id", ids).toString();
                }
            };
            var icon = $("#" + autocomplete.iconId);

            z.controls.autoComplete(autocompleteArgs);

            icon.tie("click", function () {
                var popUp = z.controls.searchPopUp({
                    id: entityType + "_" + autocomplete.iconId,
                    title: z.ll(entityType),
                    types: [
                        z.searchTypes.generate({
                            entityType: entityType,
                            filter: function () {
                                var ids = $.map(me.data, function (data) {
                                    return data[entityType + "Id"];
                                });

                                return z.filter.isNotIn("Id", ids).toString();
                            }
                        })
                    ],
                    okClick: function () {
                        var searchWindow = popUp.window;
                        if (searchWindow.searchResults != null) {
                            observable.set(entityType, searchWindow.searchResults);
                            observable.set(entityType + "Id", searchWindow.searchResults.Id);

                            me.zScreen[autocomplete.searchResultsCallback] && me.zScreen[autocomplete.searchResultsCallback]({ data: searchWindow.searchResults,  searchWindow: searchWindow, observable: observable });
                        }
                    }
                });
            });
        });

        observable.bind("change", function (e) {
            if (me.zScreen && me.observableName && me.zScreen[me.observableName]) {
                var observableChildren = "";
                if (me.observableChildren) {
                    observableChildren = me.observableChildren.join(".") + ".";
                }
                me.zScreen[me.observableName].set(observableChildren + me.entityAlias + "[" + observable.rowId + "]." + e.field, observable[e.field]);
                me.zScreen[me.observableName].set(observableChildren + me.entityAlias + "[" + observable.rowId + "].dirty", true);
            }
        });

        var row: any = $("#" + me.id + "_Row" + index);

        row.find(".trash").tie("click", function () {

            var bindValues = me.mainColumn.bindValue.split(".");
            var unfinishedRow = false;
            var data = z.clone(observable);

            for (var iii = 0; iii < bindValues.length; iii++) {
                var value = bindValues[iii];
                if (data[value]) {
                    data = data[value];
                } else {
                    unfinishedRow = true;
                }
            }

            var afterDelete = function () {
                var autocompletesToDestroy = me.tableDataContainer.find(".k-autocomplete input");

                $.each(autocompletesToDestroy, function (i, autocomplete) {
                    $(autocomplete).data("kendoAutoComplete").destroy();
                });
                me.tableDataContainer.empty();
                me.bindData({ parentId: me.parentId });

                if (!observable.Id && !unfinishedRow) {
                    z.controls.alert({
                        header: z.ll("DeleteSuccess"),
                        message: z.ll("DeleteSuccessMessage").format(z.ll(me.entityAlias)),
                        type: "success"
                    });
                }
            };

            if (observable.Id) {
                if (me.checkCount) {
                    z.ajax({
                        url: "" + me.entityAlias + "/" + me.entityAlias + "Count/" + me.zScreen[me.observableName].Id,
                        type: "GET"
                    }).done(function (countData) {
                        if (countData.d.results > 1) {
                            z.util.deleteEntity({
                                id: observable.Id,
                                entity: me.entityAlias,
                                success: function () {
                                    afterDelete();
                                }
                            });
                        } else {
                            z.controls.alert({ type: "danger", header: z.ll("DeleteFailed"), message: z.ll("CannotDeleteLastObject").format(z.ll(me.entityAlias)) });
                        }
                    });
                } else {
                    z.util.deleteEntity({
                        id: observable.Id,
                        entity: me.entityAlias,
                        success: function () {
                            afterDelete();
                        }
                    });
                }
            } else {
                afterDelete();
            }
        });

        if (me.data.length >= me.maxRows) {
            me.container.find(".add").disable();
        } else {
            me.container.find(".add").enable();
        }
    }

    setDataSource(dataSource) {
        var me = this;
        dataSource = dataSource || z.observable([]);
        if (dataSource instanceof kendo.data.DataSource) {
            me.dataSource = dataSource;
        } else {
            me.dataSource = new kendo.data.DataSource({
                data: dataSource
            });
        }
        me.dataSource.bind("change", function (e) {
            if (e.action && e.action == "itemchange") {
                me.events && me.events.change && $.each(me.events.change, function (i, callback) {
                    callback({ sender: me, data: e.items[0], field: e.field });
                });
            }
            if (!e.action) {
                me.refresh();
            }
        });

        me.dataSource && me.dataSource.fetch();
    }

    refresh() {
        var me = this;
        var dataContainer = $("#" + me.id + " .editable-data-container");
        var elements = $(dataContainer).find("*");
        $.each(elements, function (i, elem) {
            var element = $(elem);
            var dataNames = Object.keys(element.data());

            $.each(dataNames, function (j, name) {
                if (name.substring(0, 5) == "kendo") {
                    var kendo = element.data(name);
                    if (kendo && kendo.destroy) {
                        kendo.destroy();
                        return false;
                    }
                }
                return true;
            });
        });

        elements.remove();

        var rows = [];
        var data = me.dataSource._data;
        if (!data || data.length == 0) {
            me.addRow();
            return;
        }

        $.each(data, function (index, item) {
            if (!item.Deleted) {

                var currentRow: EditableTableColumn[] = [];
                $.each(me.dataTemplate, function (x, component) {
                    currentRow.push($.extend({}, component));
                });

                var currentRowId = me.id + "_er" + index;
                $.each(currentRow, function (i2, field) {
                    field.id = currentRowId + "_" + field.id;
                    if (field.iconId) {
                        field.iconId = currentRowId + "_" + field.iconId;
                    }

                    if (field && field.bindValue) {
                        field.bindValue = field.field;
                    }
                });

                var components: ui.Component[] = [];
                $.each(currentRow, function (x, component) {
                    if (component.type == "ComboBox") {
                        components.push(new ui.ComboBox(component));
                    } else if (component.type == "Label") {
                        components.push(new ui.Label(component));
                    } else if (component.type == "NumericInput") {
                        components.push(new ui.NumericInput(component));
                    } else if (component.type == "TextBox") {
                        components.push(new ui.TextBox(component));
                    }
                });

                components.push(
                    new ui.Element({
                        classes: "trash" + (me.recursiveDisable ? " field-visibility-disabled" : ""),
                        containerClasses: me.recursiveDisable ? "field-visibility-disabled" : "",
                        toolTip: "Remove" + me.options.tableType,
                        disabled: me.disabled
                    })
                );

                var rowObservable = z.observable(data[index]);
                var container = new ui.Container({
                    id: currentRowId,
                    type: "Container",
                    classes: "editable-row-container",
                    components: components,
                    observable: rowObservable
                });
                container.render(dataContainer);

                z.bind({ container: "#" + currentRowId, bind: ".bind-value", data: rowObservable });

                $("#" + currentRowId).data("row", currentRow);

                rows.push(container.options);
            }
        });

        $.each(rows, function (index, row) {
            var deletedLength = me.countRow();
            if ((me.dataSource._data.length - deletedLength) <= 1 && me.options.required) {
                $("#" + row.id).find(".trash").addClass("disabled");
                return;
            }
            $("#" + row.id).find(".trash").tie("click", function () {
                var callbackObject = {
                    sender: me,
                    row: row,
                    isDefaultPrevented: function () {
                        return this.defaultPrevented;
                    },
                    preventDefault: function () {
                        this.defaultPrevented = true;
                    },
                    defaultPrevented: false
                };

                me.events && me.events.remove && $.each(me.events.remove, function (i, callback) {
                    callback(callbackObject);
                });

                if (!callbackObject.isDefaultPrevented()) {
                    row.observable.set("DeletedDateTime", new Date());
                    row.observable.set("Deleted", true);
                    if (row.Deleted && !row.Id) {
                        me.dataSource.remove(me.dataSource.at(index));
                    }

                    me.saveChanges();
                    me.refresh();
                }
            });
        });

        me.events && me.events.dataBound && $.each(me.events.dataBound, function (i, callback) {
            callback({ sender: me, rows: rows });
        });
    }

    bind(event, callback) {
        var me = this;
        me.events = me.events || {};

        me.events[event] = me.events[event] || [];
        me.events[event].push(callback);
    }

    saveChanges() {
        var me = this;
        me.dataSource.sync();
    }

    countRow() {
        var me = this;
        return $.map(me.dataSource._data.toJSON(), function (c) {
            return c.Deleted;
        }).length;
    }

}
